



export function createCheckeredCircleIcon(config) {

    if (typeof(config) === "number") {
        config = {size:config}
    }

    //stroke="black" stroke-width="4"

    const size = config.size || 20
    const c1 = config.color1 || "black"
    const c2 = config.color2 || "white"
    const chqsize = config.checksize || size / 8
    const stroke = config.stroke || "black"
    let strokewidth = config.strokewidth
    if (typeof(strokewidth) !== "number") {
        strokewidth = 5
    }

    const mx = (size + strokewidth) / 2
    const my = (size + strokewidth) / 2

    const squareSize = chqsize; // Each square's size
    const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="${size + strokewidth}" height="${size + strokewidth}">
            <defs>
                <pattern id="checkered" patternUnits="userSpaceOnUse" width="${squareSize * 2}" height="${squareSize * 2}">
                    <rect width="${squareSize}" height="${squareSize}" fill="${c1}" />
                    <rect x="${squareSize}" y="${squareSize}" width="${squareSize}" height="${squareSize}" fill="${c1}" />

                    <rect x="${squareSize}" width="${squareSize}" height="${squareSize}" fill="${c2}" />
                    <rect y="${squareSize}" width="${squareSize}" height="${squareSize}" fill="${c2}" />
                </pattern>
            </defs>
            <circle cx="${mx}" cy="${my}" r="${size / 2}" fill="url(#checkered)" stroke="${stroke}" stroke-width="${strokewidth}" />
        </svg>
    `;
    return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
}

export function createNumberedCircleIcon(config) {

    const size = config.size || 20
    const c1 = config.color || "white"
    const stroke = config.stroke || "black"
    let strokewidth = config.strokewidth
    if (typeof(strokewidth) !== "number") {
        strokewidth = 5
    }

    const mx = (size + strokewidth) / 2
    const my = (size + strokewidth) / 2

    let texttag = ""
    if (typeof(config.number) === "number") {
        texttag = `<text x="${mx}" y="${my}" font-size="${size / 2}" text-anchor="middle" alignment-baseline="middle" fill="${config.fontcolor}">${config.number}</text>`
    }

    const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="${size + strokewidth}" height="${size + strokewidth}">
            <circle cx="${mx}" cy="${my}" r="${size / 2}" fill="${c1}" stroke="${stroke}" stroke-width="${strokewidth}" />
            ${texttag}
        </svg>
    `;
    return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
}